var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false, title: "辅助明细账" } },
        [
          _vm.missingCategories.length
            ? _c("a-alert", {
                staticStyle: { "margin-bottom": "12px" },
                attrs: {
                  type: "warning",
                  showIcon: "",
                  message: `当前账套辅助类别不全（仅 ${
                    _vm.dimensions.length
                  } 类），缺失：${_vm.missingCategories.join(
                    "、"
                  )}。建议在【基础资料 → 辅助核算类别】补齐，或重建账套以加载模板 9 类。`,
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "辅助维度",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  on: { change: _vm.onCategoryChange },
                                  model: {
                                    value: _vm.categoryId,
                                    callback: function ($$v) {
                                      _vm.categoryId = $$v
                                    },
                                    expression: "categoryId",
                                  },
                                },
                                _vm._l(_vm.dimensions, function (d) {
                                  return _c(
                                    "a-select-option",
                                    { key: d.id, attrs: { value: d.id } },
                                    [_vm._v(_vm._s(d.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "核算对象",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    showSearch: "",
                                    optionFilterProp: "children",
                                    placeholder: "选择明细",
                                  },
                                  on: { change: _vm.searchQuery },
                                  model: {
                                    value: _vm.detailId,
                                    callback: function ($$v) {
                                      _vm.detailId = $$v
                                    },
                                    expression: "detailId",
                                  },
                                },
                                _vm._l(_vm.auxDetails, function (d) {
                                  return _c(
                                    "a-select-option",
                                    { key: d.id, attrs: { value: d.id } },
                                    [
                                      _vm._v(
                                        _vm._s(d.name) +
                                          _vm._s(
                                            d.code ? " (" + d.code + ")" : ""
                                          )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "起始月份",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-month-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { format: "YYYY-MM" },
                                model: {
                                  value: _vm.beginMoment,
                                  callback: function ($$v) {
                                    _vm.beginMoment = $$v
                                  },
                                  expression: "beginMoment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "截止月份",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-month-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { format: "YYYY-MM" },
                                model: {
                                  value: _vm.endMoment,
                                  callback: function ($$v) {
                                    _vm.endMoment = $$v
                                  },
                                  expression: "endMoment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "门店",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("store-tenant-select", {
                                attrs: { domain: "finance" },
                                on: { change: _vm.handleStoreTenantChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "table-page-search-submitButtons" },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.searchQuery },
                              },
                              [_vm._v("查询")]
                            ),
                            _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "8px" },
                                on: { click: _vm.searchReset },
                              },
                              [_vm._v("重置")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.materialInfo
            ? _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                _c("span", { staticStyle: { "margin-right": "24px" } }, [
                  _vm._v("编码：" + _vm._s(_vm.materialInfo.code || "-")),
                ]),
                _c("span", { staticStyle: { "margin-right": "24px" } }, [
                  _vm._v("名称：" + _vm._s(_vm.materialInfo.name || "-")),
                ]),
                _c("span", { staticStyle: { "margin-right": "24px" } }, [
                  _vm._v("规格：" + _vm._s(_vm.materialInfo.standard || "-")),
                ]),
                _c("span", [
                  _vm._v("单位：" + _vm._s(_vm.materialInfo.unit || "-")),
                ]),
              ])
            : _vm._e(),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: false,
              loading: _vm.loading,
              scroll: _vm.tableScroll,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }